const MarkerPopup = ({ entity, colorsArray, innerIcon, filtersKeys }) => {
  const infos = entity.typeInfos[0];

  let lang = document.getElementById("root").dataset.lang;

  //--- Format Email
  // let displayEmail = [];
  // if (infos.email && Object.entries(infos.email).length > 0) {
  //   const formatedEmail = Object.entries(infos.email);
  //   displayEmail = formatedEmail.map((elt, index) => {
  //     const [person, email] = elt;
  //     return (
  //       <div>
  //         <div key={email + index}>
  //           {/* <div className="text-bold">{person} : </div> */}
  //           <div>{email}</div>
  //         </div>
  //       </div>
  //     );
  //   });
  // }
  let template = "";
  if (filtersKeys[0]) {
    template = filtersKeys[0];
  }

  let websiteURL = "";
  if (entity.website) {
    if (!entity.website.includes("http")) {
      websiteURL = "http://" + entity.website;
    } else {
      websiteURL = entity.website;
    }
  }

  return (
    <>
      {entity[template][0] === "producteurs" ? (
        <div className="producteurs">
          <div className="institution-name" style={{ color: colorsArray[0] }}>
            {entity.name}
          </div>
          <div className="cdg-marker-popup__contact-block">
            <div className="left-block">
              <div className="in-charge">{infos.inCharge}</div>
              {infos.phone.Tel && (
                <a className="tel" href={`tel:+33${infos.phone.Tel}`} style={{ color: colorsArray[0] }}>
                  {infos.phone.Tel}
                </a>
              )}
              {infos.email && (
                <a href={`mailto:${infos.email}`} className="email">
                  {infos.email}
                </a>
              )}
              {entity.website && (
                <a className="website" target="_blank" href={websiteURL} style={{ color: colorsArray[0] }}>
                  {entity.website}
                </a>
              )}
            </div>
            <div className="right-block">
              {infos.InstitutionPage && (
                <a className="institution-page" href={infos.InstitutionPage}>
                  {lang === "fr-FR" ? "VOIR LA FICHE" : "SEE THE PAGE"}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                    <path d="M351.29 133.4c-5.86-5.86-15.36-5.86-21.21 0-5.86 5.86-5.86 15.36 0 21.21l87.32 87.32H46.39c-8.28 0-15 6.72-15 15s6.72 15 15 15H417.4l-87.32 87.32c-5.86 5.86-5.86 15.36 0 21.21 2.93 2.93 6.77 4.39 10.61 4.39s7.68-1.46 10.61-4.39l123.53-123.53L351.3 133.4z" />
                  </svg>
                </a>
              )}
            </div>
          </div>
          {lang === "fr-FR" ? (
            <div
              className="cdg-marker-popup__description"
              dangerouslySetInnerHTML={{ __html: entity["description_fr-FR"] }}
            ></div>
          ) : (
            <div
              className="cdg-marker-popup__description"
              dangerouslySetInnerHTML={{ __html: entity["description_en-US"] }}
            ></div>
          )}
          <div className="cdg-marker-popup__address-block">
            <div className="address-wrapper">
              <div className="address">{infos.address}</div>
              <div className="address-complement">{infos.addressComplement}</div>
            </div>
            {infos.googleMapRoute && (
              <a
                className="google-map-route"
                style={{ backgroundColor: colorsArray[0] }}
                href={infos.googleMapRoute}
                target={"_blank"}
              >
                {lang === "fr-FR" ? "J'Y VAIS" : "ITINERARY"}
              </a>
            )}
          </div>
          <div className="cdg-marker-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
              <path
                fill={colorsArray[0]}
                d="M459.4 217.81c0-116.15-94.57-210.21-210.91-209.39-113.5.8-206.39 93.11-207.86 206.61-1 76.88 39.45 144.39 100.41 181.61 40.1 24.48 75.68 55.69 104.09 93.11l4.39 5.78 13.53-16.23c26.86-32.21 58.53-60.23 94.49-81.8 61.02-36.59 101.86-103.37 101.86-179.69z"
              />
            </svg>
            <div className="innerIcon" dangerouslySetInnerHTML={{ __html: innerIcon }}></div>
          </div>
        </div>
      ) : (
        <div className="cavistes">
          <div className="institution-name" style={{ color: colorsArray[0] }}>
            {entity.name}
          </div>
          <div className="cdg-marker-popup__address-block">
            <div className="address-wrapper">
              <div className="address">{infos.address}</div>
              <div className="address-complement">{infos.addressComplement}</div>
            </div>
          </div>
          <a
            className="google-map-route"
            style={{ backgroundColor: colorsArray[0] }}
            href={infos.googleMapRoute}
            target={"_blank"}
          >
            {lang === "fr-FR" ? "J'Y VAIS" : "ITINERARY"}
          </a>
          <div className="cdg-marker-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
              <path
                fill={colorsArray[0]}
                d="M459.4 217.81c0-116.15-94.57-210.21-210.91-209.39-113.5.8-206.39 93.11-207.86 206.61-1 76.88 39.45 144.39 100.41 181.61 40.1 24.48 75.68 55.69 104.09 93.11l4.39 5.78 13.53-16.23c26.86-32.21 58.53-60.23 94.49-81.8 61.02-36.59 101.86-103.37 101.86-179.69z"
              />
            </svg>
            <div className="innerIcon" dangerouslySetInnerHTML={{ __html: innerIcon }}></div>
          </div>
        </div>
      )}
    </>
  );
};

export default MarkerPopup;
